import { DateTimePicker } from "@mui/x-date-pickers-pro";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import InvestorCommunicationContext from "../InvestorCommunicationContext";
import { setPublishedAtAction } from "../investorCommunicationEditState";

const InvestorCommunicationPublishDateField = () => {
  const { state, setState, hasEditPermissions, isSaving, validationErrors } = useDefinedContext(
    InvestorCommunicationContext,
    "InvestorCommunicationContext"
  );

  return (
    <DateTimePicker
      value={state.publishedAt ?? null}
      disableFuture
      disabled={!hasEditPermissions || isSaving}
      onChange={(publishedAt) => setState(setPublishedAtAction(publishedAt ?? undefined))}
      slotProps={{
        textField: { error: validationErrors.publishedAt !== undefined, helperText: validationErrors.publishedAt },
      }}
    />
  );
};

export default InvestorCommunicationPublishDateField;
